import styles from './constants.scss';

/**
 * @todo FC-739
 * Cтоит экспортировать этот брейкпоинт из @ott/layout-context?
 * - Да – экспортировать и добавить информацию в README
 * - Нет – просто удалить комментарий
 */
export const BREAKPOINT_DESKTOP_FROM = parseInt(styles.minDesktop, 10);

export const SSR = {
  VIEWPORT_WIDTH: BREAKPOINT_DESKTOP_FROM,
  VIEWPORT_HEIGHT: BREAKPOINT_DESKTOP_FROM * 0.75, // 1.33:1

  IS_TOUCH_DEVICE: false,
};
